<template>
  <b-card :header="`${productid} - ${itemdescription} |  ${person}`">
    <b-row class="no-mar">
      <b-col md="6">
        <form-element
          v-model="product.lfc"
          :form-element="{
            type: 'select',
            name: 'productLeft',
            options,
            placeholder: $t('productLeft'),
            label: $t('productLeft'),
            required: true,
            selectLabel: 'key',
            size: 12,
          }"
        />
      </b-col>
      <b-col md="6">
        <form-element
          v-model="product.rfc"
          :form-element="{
            type: 'select',
            name: 'productRight',
            options,
            placeholder: $t('productRight'),
            label: $t('productRight'),
            required: true,
            selectLabel: 'key',
            size: 12,
          }"
        />
      </b-col>
      <b-col md="12">
        <b-form-checkbox
          v-if="allowRepair && commentFieldRequired"
          v-model="product.repair"
          name="repair"
          :value="true"
          :unchecked-value="false"
        >
          {{ $t("thisProductWillBeSendBackForRepair") }}
        </b-form-checkbox>
        <form-element
          v-if="product.lfc || product.rfc"
          v-model="product.comment"
          :form-element="{
            type: 'textarea',
            name: 'comment',
            options,
            placeholder: $t('comment'),
            label: $t('comment'),
            required: commentFieldRequired,
            size: 12,
            maxLength: 178 // Max 200 minus the default text in case of repair. See the RepairProduct method in FunctionControlHandler.cs (App_Code).
          }"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BRow, BCol, BCard, BFormCheckbox } from "bootstrap-vue"
import FormElement from "../form/FormElement.vue"

export default {
  components: {
    BRow,
    BCol,
    BCard,
    FormElement,
    BFormCheckbox,
  },
  props: {
    productid: {
      type: Number,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    itemdescription: {
      type: String,
      required: true,
    },
    person: {
      type: String,
      required: false,
      default: function () {
        return ""
      },
    },
    options: {
      type: Array,
      required: true,
    },
    allowRepair: {
      type: Boolean,
      required: false,
      default() {
        return false
      },
    },
  },
  data() {
    return {
      product: {
        lfc: null,
        rfc: null,
      },
    }
  },
  computed: {
    productRight: function () {
      return this.product.rfc
    },
    productLeft: function () {
      return this.product.lfc
    },
    rejectedOptions: function () {
      return ["01", "02", "03"]
    },
    commentFieldRequired: function () {
      if (
        this.rejectedOptions.includes(this.productLeft) ||
        this.rejectedOptions.includes(this.productRight)
      ) {
        return true
      }
      return false
    },
  },
  watch: {
    productRight: function () {
      this.$emit("input", this.product)
    },
    productLeft: function () {
      this.$emit("input", this.product)
    },
  },
  created() {
    this.product = this.value
  },
}
</script>
